import { useLogout } from "features/authentication/actions";
import React from "react";

export function LogoutButton() {
  const logout = useLogout();
  // eslint-disable-next-line jsx-a11y/anchor-is-valid
  return <a onClick={logout}>Logga ut</a>;
}
